import { Box, Flex } from "@jewlr/storybook/core"
import React from "react"
import styled from "styled-components"

const Banner = styled(Box)`
  background: ${(props) => props.theme.colors.black};
  border-radius: 8px;
  color: ${(props) => props.theme.colors.white};
  display: inline-block;
  font-size: 16px;
  height: 28px;
  line-height: 28px;
  padding: 0 10px;
  text-align: center;
`

const OutOfStockBanner = () => (
  <Flex justifyContent="center" mt={1}>
    <Banner>
      This item is currently <b>Out of Stock</b>
    </Banner>
  </Flex>
)

export default OutOfStockBanner
